// extracted by mini-css-extract-plugin
export default {"navigater":"navigater_navigater__WSCZT","path":"navigater_path__CKjkM"};